// eslint-disable-next-line @typescript-eslint/no-explicit-any
let worker: any;

async function getWorker() {
  // eslint-disable-next-line no-constant-condition, no-undef
  if (__ENABLE_MOCKS__) {
    if (!worker) {
      const { setupWorker } = await import('msw');
      const { handlers } = await import('../handler');

      worker = setupWorker(...handlers);
    }

    return worker;
  }

  return undefined;
}

export { getWorker };
